import script from "./SectionWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./SectionWrapper.vue?vue&type=style&index=0&id=7d614379&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d614379"]])

export default __exports__